import * as client from "./client/index";
import * as clientPbl from "./client-pbl/index";

enum AppType {
  ADMIN = "admin",
  ADMIN_PBL = "adminPbl",
  CLIENT = "client",
  CLIENT_PBL = "clientPbl",
}

const appType = import.meta.env.VITE_APP_TYPE;

const BaseCheckLike = appType === AppType.CLIENT ? client.BaseCheckLike : clientPbl.BaseCheckLike;
const BaseEasyTable = appType === AppType.CLIENT ? client.BaseEasyTable : clientPbl.BaseEasyTable;
const BasePagination = appType === AppType.CLIENT ? client.BasePagination : clientPbl.BasePagination;
const BaseSearchForm = appType === AppType.CLIENT ? client.BaseSearchForm : clientPbl.BaseSearchForm;
const BaseTable = appType === AppType.CLIENT ? client.BaseTable : clientPbl.BaseTable;
const BaseComboBox = appType === AppType.CLIENT ? client.BaseComboBox : clientPbl.BaseComboBox;
/** Base 객체 */
export const Base = {
  Breadcrumb: client.BaseBreadcrumb,
  Button: client.BaseButton,
  Checkbox: client.BaseCheckbox,
  CheckLike: BaseCheckLike,
  Chips: client.BaseChips,
  DateInput: client.BaseDateInput,
  EasyTable: BaseEasyTable,
  FilterSelect: client.BaseFilterSelect,
  Input: client.BaseInput,
  Pagination: BasePagination,
  Popup: client.BasePopup,
  Radio: client.BaseRadio,
  SearchForm: BaseSearchForm,
  Select: client.BaseSelect,
  SelectSearch: client.BaseSelectSearch,
  Tab: client.BaseTab,
  Table: BaseTable,
  Textarea: client.BaseTextarea,
  TimeInput: client.BaseTimeInput,
  TinyEditor: client.BaseTinyEditor,
  ToggleSwitch: client.BaseToggleSwitch,
  FileUpload: client.BaseFileUpload,
  ComboBox: client.BaseComboBox,
};
